<div class="p-2">
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>

    <!-- Custom Modal for Upcoming Interactions -->
    <app-custom-confirm-modal
        [isVisible]="showUpcomingInteractionsModal"
        title="Upcoming Interactions Found" i18n-title
        [message]="upcomingInteractionsMessage"
        confirmLabel="Mark All Complete & Create Contract" i18n-confirmLabel
        cancelLabel="Cancel" i18n-cancelLabel
        (confirm)="onConfirmUpcomingInteractions()"
        (cancel)="onCancelUpcomingInteractions()">
    </app-custom-confirm-modal>

    <!-- Initial Loading State -->
    <div *ngIf="isLoadingReservation && !reservationError" class="flex items-center justify-center min-h-screen">
        <div class="text-center">
            <p-progressSpinner styleClass="w-16 h-16" strokeWidth="3" animationDuration="1s"></p-progressSpinner>
            <p class="text-gray-600 mt-4 text-lg">Loading reservation details...</p>
            <p class="text-gray-500 mt-2 text-sm">Please wait while we fetch the reservation data</p>
        </div>
    </div>

    <!-- Error State -->
    <div *ngIf="reservationError" class="flex items-center justify-center min-h-screen">
        <div class="text-center">
            <i class="pi pi-exclamation-triangle text-red-500 text-6xl mb-4"></i>
            <h2 class="text-xl font-semibold text-gray-800 mb-2">Error Loading Reservation</h2>
            <p class="text-gray-600 mb-4">{{ reservationError }}</p>
            <p-button appGlobalLoadingDisable 
                i18n-label
                label="Try Again" 
                icon="pi pi-refresh" 
                (onClick)="retryLoading()"
                severity="secondary">
            </p-button>
        </div>
    </div>

    <!-- Main Content -->
    <div *ngIf="!isLoadingReservation && !reservationError">
        <!-- Header Section -->
        <div class="flex flex-wrap justify-between gap-2 items-center mb-6">
            <div>
                <h1 class="text-3xl font-bold flex items-center gap-2">
                    <span *ngIf="isLoadingReservation">
                        <p-skeleton height="40px" width="200px"></p-skeleton>
                    </span>
                    <span *ngIf="!isLoadingReservation" class="flex flex-col md:flex-row items-start md:items-center gap-2">
                        {{reservationData.customerName}}
                        <span
                            class="text-[#475569] text-[10px] bg-[#6B7280] text-normal rounded-full px-2 py-1 mb-2 mt-1 text-white">
                            {{reservationData.refNo || reservationData.reservationNumber}}
                        </span>
                    </span>
                </h1>
                <div class="flex flex-wrap gap-2 mt-2">
                    <div *ngIf="isLoadingReservation" class="flex flex-wrap gap-2">
                        <p-skeleton height="24px" width="80px"></p-skeleton>
                        <p-skeleton height="24px" width="80px"></p-skeleton>
                        <p-skeleton height="24px" width="80px"></p-skeleton>
                    </div>
                    <p *ngFor="let product of reservationData.products" 
                       class="text-[#6B7280] text-sm sm:text-base bg-[#E9EBEE] px-2 py-1 rounded-full whitespace-nowrap">
                        {{product}}
                    </p>
                </div>
                <p class="text-[#6B7280] text-base my-3">
                    <span *ngIf="isLoadingReservation">
                        <p-skeleton height="20px" width="120px"></p-skeleton>
                    </span>
                    <span *ngIf="!isLoadingReservation">
                        Valid till : {{reservationData.validTill}}
                    </span>
                    
                </p>
                <p-button appGlobalLoadingDisable i18n-label label="Back to Reservations" icon="pi pi-arrow-left" class="whitespace-nowrap w-full sm:w-auto"
                styleClass="p-button-outlined p-button-secondary" 
                (onClick)="onCustomerPage()" />
            </div>
            <div class="flex flex-col sm:flex-row gap-3" *ngIf="reservationData.status === 'Pending' && !isSAOrA()">
               
                <p-button appGlobalLoadingDisable label="Close Reservation" class="whitespace-nowrap w-full sm:w-auto"
                    styleClass="p-button-outlined p-button-secondary" 
                    (onClick)="onCloseReservation()" />
                <p-button appGlobalLoadingDisable label="Schedule Next Interaction" icon="pi pi-plus"
                   
                    class="whitespace-nowrap w-full sm:w-auto" 
                    (onClick)="onScheduleNextInteraction()" />
                <p-button appGlobalLoadingDisable label="Convert to Contract" icon="pi pi-file-export"
                    class="whitespace-nowrap w-full sm:w-auto" 
                    styleClass="p-button-success"
                    (onClick)="onConvertToContract()" />
            </div>
            
            <div class="flex flex-col sm:flex-row gap-3" *ngIf="reservationData.status === 'Interested' && !isSAOrA()">
                <p-button appGlobalLoadingDisable label="Schedule Next Interaction" icon="pi pi-plus"
                    class="whitespace-nowrap w-full sm:w-auto" 
                    (onClick)="onScheduleNextInteraction()" />
                <p-button appGlobalLoadingDisable label="Convert to Contract" icon="pi pi-file-export"
                    class="whitespace-nowrap w-full sm:w-auto" 
                    styleClass="p-button-success"
                    (onClick)="onConvertToContract()" />
            </div>
        </div>
    </div>

    <!-- View Interactions Section -->
    <h2 class="text-2xl font-bold text-gray-800 mb-4 mt-6" i18n>View Interactions</h2>

    <p-card class="!p-3">
        <div class="overflow-x-auto min-h-screen">
            <p-table 
                [value]="interactions || []" 
                [loading]="isLoading"
                [paginator]="false" 
                [tableStyle]="{'min-width': '900px', 'width': '100%'}"
                styleClass="p-datatable-sm p-datatable-striped">

                <!-- Header -->
                <ng-template pTemplate="header">
                    <tr>
                        <th class="min-w-[120px]">REF NO</th>
                        <th class="min-w-[100px]">DATE</th>
                        <th class="min-w-[100px]">TIME</th>
                        <th class="min-w-[100px]">TYPE</th>
                        <th class="min-w-[100px]">STATUS</th>
                        <th class="min-w-[100px]">NOTES</th>
                        <th class="min-w-[180px]">ACTIONS</th>
                    </tr>
                </ng-template>

                <!-- Body -->
                <ng-template pTemplate="body" let-interaction>
                    <tr>
                        <!-- Ref No -->
                        <td class="min-w-[120px]">
                            <div class="text-sm font-medium text-gray-900">
                                {{ interaction.refNo || 'N/A' }}
                            </div>
                        </td>
                        
                        <!-- Date -->
                        <td class="min-w-[100px]">
                            <div class="flex items-center gap-3">
                                <div>
                                    <div class="font-normal text-sm text-[#111827]">
                                        {{formatDate(interaction.interactionDate)}}
                                    </div>
                                </div>
                            </div>
                        </td>

                        <!-- Time -->
                        <td class="min-w-[100px] text-start">
                            <div class="text-start">
                                <div class="text-sm font-normal text-[#6B7280]">
                                    {{formatTime(interaction.interactionTime)}}
                                </div>
                            </div>
                        </td>

                        <!-- Type -->
                        <td class="min-w-[100px] text-start">
                            <p-tag [value]="interaction.interactionType.replace('_', ' ')" 
                                   [style]="{'background-color': '#DBEAFE', 'color': '#1E40AF'}">
                            </p-tag>
                        </td>

                        <!-- Status -->
                        <td class="min-w-[100px]">
                            <p-tag [value]="getStatusTag(interaction).value" 
                                   [severity]="getStatusTag(interaction).severity"
                                   [style]="{'background-color': getStatusColor(interaction) === 'purple' ? '#E5C6FF' : '#DCFCE7', 
                                             'color': getStatusColor(interaction) === 'purple' ? '#6B21A8' : '#166534'}">
                            </p-tag>
                        </td>

                        <!-- Notes -->
                        <td class="min-w-[100px] max-w-[230px]">
                            <span class="text-gray-600 text-sm line-clamp-2">
                                {{getInteractionNotes(interaction)}}
                            </span>
                        </td>

                        <!-- Actions -->
                        <td class="min-w-[180px]">
                            <div class="flex items-center gap-2">
                                <p-button *ngIf="interaction.interactionStatus === 'upcoming'"
                                         label="Log Interaction" 
                                         size="small" 
                                         [outlined]="true"
                                         (onClick)="onCompleteInteraction(interaction)">
                                </p-button>
                                <p-button *ngIf="interaction.interactionStatus === 'completed'"
                                         label="View Interaction Info" 
                                         size="small" 
                                         [outlined]="true"
                                         (onClick)="onViewVisitInfo(interaction)">
                                </p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>

                <!-- Empty State -->
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7" class="text-center py-8">
                            <div class="flex flex-col items-center gap-2">
                                <i class="pi pi-calendar text-4xl text-gray-300"></i>
                                <p class="text-gray-500">No interactions found for this reservation</p>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>

    <!-- Interactions Error State -->
    <div *ngIf="loadingError && !isLoading" class="mt-6">
        <p-card>
            <div class="text-center py-8">
                <i class="pi pi-exclamation-triangle text-red-500 text-4xl mb-4"></i>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Error Loading Interactions</h3>
                <p class="text-gray-600 mb-4">{{ loadingError }}</p>
                <p-button appGlobalLoadingDisable 
                    label="Retry" 
                    icon="pi pi-refresh" 
                    (onClick)="loadInteractions()"
                    severity="secondary">
                </p-button>
            </div>
        </p-card>
    </div> <!-- End of main content -->
</div>

<!-- Interaction Info Drawer -->
<p-drawer 
  [(visible)]="isDrawerVisible" 
  position="right" 
  [modal]="true" 
  [style]="{width: '90vw', maxWidth: '500px'}"
  (onHide)="onCloseDrawer()">
  
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full">
      <h3 class="text-xl font-bold text-gray-800">Interaction Info</h3>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div *ngIf="selectedInteraction" class="space-y-6">
      <!-- Date and Time with Type Tag -->
      <div class="flex items-start justify-between">
        <div class="space-y-1">
          <p class="text-gray-600 text-sm">{{ formatDate(selectedInteraction.interactionDate) }}</p>
          <p class="text-gray-600 text-sm">{{ formatTime(selectedInteraction.interactionTime) }}</p>
        </div>
        <p-tag 
          [value]="getInteractionTypeDisplay(selectedInteraction)" 
          [style]="{'background-color': '#DBEAFE', 'color': '#1E40AF'}">
        </p-tag>
      </div>

      <!-- Interaction Notes -->
      <div class="space-y-2">
        <p class="text-gray-800 leading-relaxed">
          {{ getInteractionNotes(selectedInteraction) }}
        </p>
      </div>

      <!-- Attachments -->
      <div *ngIf="selectedInteraction.documents && selectedInteraction.documents.length > 0" class="space-y-3">
        <h4 class="font-bold text-gray-800">Attachments</h4>
        <div class="space-y-2">
          <div *ngFor="let doc of selectedInteraction.documents" class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
            <div [class]="'w-6 h-6 ' + getFileIcon(doc).bgColor + ' rounded flex items-center justify-center'">
              <span class="text-white text-xs font-bold">{{ getFileIcon(doc).label }}</span>
            </div>
            <span class="text-gray-700 flex-1">{{ doc.split('/').pop() || 'Document' }}</span>
            <button 
              (click)="downloadDocument(doc)" 
              class="w-6 h-6 text-gray-500 hover:text-gray-700 transition-colors cursor-pointer">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- No Attachments Message -->
      <div *ngIf="!selectedInteraction.documents || selectedInteraction.documents.length === 0" class="text-center py-4">
        <p class="text-gray-500 text-sm">No attachments available</p>
      </div>
    </div>
  </ng-template>
</p-drawer>